import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SelectField from 'components/molecules/select-field'
import { useField } from 'formik'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool,
  options  : PropTypes.array
}

/**
p * Selectfield for Product Size. Only to be used within a Formik component.
 * @param {string} name - Represent key value in FormikBag
 * @param {string} label - Field name in the input label
 * @param {bool} required - It will show required badge if it's `true`
 * @param {array} options - Product Size options
 */
const ProductSizeSelectField = ({
  label,
  required,
  options,
  ...props
}) => {

  const [ field ] = useField(props)

  /** Format the option structure to follow react-select convention */
  const formattedOption = (option) => ({
    value : option.id,
    label : option.label
  })

  /**
   * transform the option into react-select standard option format
   * wrapping with useMemo to prevent unecessary rendering
   */
  const sizeOptions = useMemo(() => options.map((option) => formattedOption(option)), [ options ])

  /**
   * Custom handler filter options that triggered when user type.
   * @param {string} inputValue - Input value from the field
   * @returns {array} list of options that already transform into react-select standart option
   */
  const handleFilterOptions = (inputValue) => {
    const selectedOptions = sizeOptions.filter((option) => option.label.toLowerCase().startsWith(inputValue))
    return selectedOptions
  }

  return (
    <SelectField
      { ...props }
      { ...field }
      label={ label }
      required={ required }
      defaultOptions={ sizeOptions }
      defaultValue={ sizeOptions.find((option) => option.value === field.value) }
      onFilterOptions={ handleFilterOptions }
    />
  )
}

ProductSizeSelectField.propTypes = propTypes

export default ProductSizeSelectField
